// Essay metadata only — deliberately free of any visualization or JSON imports so the
// landing page (and therefore the main bundle) stays light.
//
// All three essays are now scrolling pieces with their own page and their own
// per-scene data loading, so there is no longer a project loader here: the accordion
// that LOADERS used to feed has no remaining route.

// The index groups by `category` and prints the group name as a heading. The cards
// themselves are figure and title only, so nothing here needs a label describing the
// format. `subtitle` is kept for the essay pages, not for the index.
export const CATEGORIES = [
  { id: 'data-science', title: 'Natural Language Processing' },
  { id: 'just-for-fun', title: 'Just For Fun' },
  { id: 'grammar-linguistics', title: 'Grammar and Linguistics' },
];

export const ESSAYS = [
  {
    slug: 'visualizing-corpora',
    title: 'Visualizing Corpora',
    subtitle: 'Counting the words in a library, then drawing what the counts say.',
    category: 'data-science',
    accent: 'feature-card-global',
    count: 8,
    format: 'essay',
    graphic: 'circlepack',
  },
  {
    slug: 'exploring-transformers',
    title: 'Exploring Transformers',
    subtitle: 'How a machine gets from a stream of characters to a sentence.',
    category: 'data-science',
    accent: 'feature-card-ai',
    count: 11,
    format: 'essay',
    graphic: 'heatmap',
  },
  {
    slug: 'international-politics-of-information',
    title: 'The Media Ecology of Online Geopolitics',
    subtitle: 'Who gets written down, who gets counted, and in whose language.',
    category: 'data-science',
    accent: 'feature-card-photo',
    count: 3,
    format: 'essay',
    graphic: 'globe',
  },
  {
    // Titled for what it is, not for the section it sits in — and it matches the
    // page's own heading, which the old "Just For Fun" title did not.
    slug: 'just-for-fun',
    title: 'Node-edge Microbes',
    subtitle: 'A graph kept permanently warm, fed one node at a time.',
    category: 'just-for-fun',
    accent: 'feature-card-ai',
    count: 1,
    format: 'essay',
    graphic: 'microbe',
  },
  {
    slug: 'spirograph',
    title: 'Spirograph',
    subtitle: 'Scroll turns the gears; the gears draw.',
    category: 'just-for-fun',
    accent: 'feature-card-global',
    count: 1,
    format: 'essay',
    graphic: 'spiro',
  },
  {
    slug: 'mandala-mill',
    title: 'Mandala Mill',
    subtitle: 'Where a shape starts decides everything that follows.',
    category: 'just-for-fun',
    accent: 'feature-card-photo',
    count: 1,
    format: 'essay',
    graphic: 'mill',
  },
  {
    slug: 'magic-numbers',
    title: 'Magic Numbers',
    subtitle: 'Thirteen lengths that walk, and every other length that does not.',
    category: 'just-for-fun',
    accent: 'feature-card-ai',
    count: 1,
    format: 'essay',
    graphic: 'jansen',
  },
  {
    slug: 'grimms-mill',
    title: "Grimm's Mill",
    subtitle: 'The same machine with words in it. Reorder the rules, change the language.',
    category: 'grammar-linguistics',
    accent: 'feature-card-ai',
    count: 1,
    format: 'essay',
    graphic: 'grimm',
  },
  {
    slug: 'japanese-verbs',
    title: 'か・き・く・け・こ',
    subtitle: 'A Japanese verb chart is fifty boxes. It is really one small machine.',
    category: 'grammar-linguistics',
    accent: 'feature-card-global',
    count: 1,
    format: 'essay',
    graphic: 'kana',
  },
  {
    slug: 'japanese-adjectives',
    title: '高い・静かな',
    subtitle: 'Two kinds of adjective. One of them never changes at all.',
    category: 'grammar-linguistics',
    accent: 'feature-card-photo',
    count: 1,
    format: 'essay',
    graphic: 'adjective',
  },
  {
    slug: 'japanese-suffixes',
    title: '食べさせられたくなかった',
    subtitle: 'One verb, five suffixes, one word. Keep going and see what you have said.',
    category: 'grammar-linguistics',
    accent: 'feature-card-ai',
    count: 1,
    format: 'essay',
    graphic: 'suffix',
  },
];

export const essaysByCategory = (id) =>
  ESSAYS.filter((essay) => essay.category === id);

export const getEssay = (slug) => ESSAYS.find((essay) => essay.slug === slug);
